import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import styles from "./index.module.scss";
import AppCtrl from "../../../control/AppCtrl";
import Config from "../../../utils/Config";
import LANGUAGE_TYPE from "../../../utils/Language";
import EFunction from "../../../utils/FunctionPage";
import switchFunc from "../../../redux/switchFunc/switchFuncAction";
import useUserCoins from "../../../redux/userCoins/userCoinsAction";
import useAlert from "../../../hook/useAlert";

function UniPlayPage() {
  const text = Config.text.uniPlayPage;
  const { setFunc } = switchFunc();
  const { userCoins } = useUserCoins();
  const { showAlert } = useAlert();
  const navigate = useNavigate();

  //===========================================================================
  const [canExchangeUniPlayToFormal, setExchangeUniPlayToFormal] =
    useState(false);
  const [canExchangeFormalToUniPlay, setExchangeFormalToUniPlay] =
    useState(false);
  const [textUser, setTextUser] = useState("");
  const [textGold, setTextGold] = useState("");
  const [textUniPlay, setTextUniPlay] = useState("");
  const [uniPlayInfo, setUniPlayInfo] = useState(null);
  const [uniLobbyies, setUniLobbies] = useState([]);
  const [userName, setUserName] = useState("");
  const [userFormalScores, setUserFormalScores] = useState(0);
  const [userUniPlayScores, setUserUniPlayScores] = useState(0);
  const [titleUniPlayToFormal, setTitleUniPlayToFormal] = useState("");
  const [titleFormalToUniPlay, setTitleFormalToUniPlay] = useState("");
  const [scoresUniPlayToFormal, setScoresUniPlayToFormal] = useState(0);
  const [scoresFormalToUniPlay, setScoresFormalToUniPlay] = useState(0);
  const [uniPlayLobbyImg, setUniPlayLobbyImg] = useState(null);
  const [uniPlayLobbyDesc, setUniPlayLobbyDesc] = useState("");
  const [uniPlayStartDisabled, setUniPlayStartDisabled] = useState(false);

  useEffect(() => {
    componentDidMount();
    return componentWillUnmount;
  }, []);

  useEffect(() => {
    const language = AppCtrl.getLanguage();
    const mainSettings = AppCtrl.mainSettings();
    const userInfo = AppCtrl.userInfo();
    if (language == LANGUAGE_TYPE.en_US) setTextUser("User");
    else setTextUser("用戶");
    setTextGold(Config.gold[language]);
    setTextUniPlay(Config.uniPlay[language]);

    setUserName(userInfo.nickName());
    if (userCoins) {
      // show formal coins
      setUserFormalScores(userCoins.coins);
      // show formal coins
      setUserUniPlayScores(userCoins.uniPlayCoins);
    }

    setExchangeUniPlayToFormal(
      mainSettings.CanExchangeUniPlayToFormal ? true : false
    );
    setExchangeFormalToUniPlay(
      mainSettings.CanExchangeFormalToUniPlay ? true : false
    );
    if (language === LANGUAGE_TYPE.en_US) {
      setTitleUniPlayToFormal(
        `Exchange ${Config.uniPlay[language]} to ${Config.gold[language]}`
      );
      setTitleFormalToUniPlay(
        `Exchange ${Config.gold[language]} to ${Config.uniPlay[language]}`
      );
    } else {
      setTitleUniPlayToFormal(
        `將${Config.uniPlay[language]}兌換成${Config.gold[language]}`
      );
      setTitleFormalToUniPlay(
        `將${Config.gold[language]}兌換成${Config.uniPlay[language]}`
      );
    }

    const uniPlayList = AppCtrl.uniPlayList();
    if (uniPlayList) {
      const uniPlays = [];
      if (userInfo.UniPlayInfo) {
        uniPlayList.forEach((info) => {
          if (userInfo.UniPlayInfo.Domain == info.domain) {
            uniPlays.push(info.name);
          }
        });
      } else {
        uniPlayList.forEach((info) => {
          uniPlays.push(info.name);
        });
      }
      setUniLobbies(uniPlays);
    }

    setUniPlayInfo(userInfo.UniPlayInfo ? userInfo.UniPlayInfo : null);
  }, [userCoins]);

  useEffect(() => {
    const uiUniPlaySelect = document.getElementById("uniPlaySelect");
    if (uiUniPlaySelect) {
      uiUniPlaySelect.selectedIndex = -1;
      let html = "";
      for (let i = 0; i < uniLobbyies.length; i++) {
        html += `<option value=${uniLobbyies[i]}>${uniLobbyies[i]}</option>`;
      }
      uiUniPlaySelect.innerHTML = html;

      if (html.length > 0) {
        uiUniPlaySelect.selectedIndex = 0;
        const uniPlayList = AppCtrl.uniPlayList();
        const uniPlay = uniPlayList[uiUniPlaySelect.selectedIndex];
        setUniPlayLobbyImg(uniPlay.img);
        setUniPlayLobbyDesc(uniPlay.desc);
      } else {
        setUniPlayLobbyImg(null);
        setUniPlayLobbyDesc("");
      }
    }
  }, [uniLobbyies]);
  //===========================================================================

  function componentDidMount() {
    window.addEventListener("resize", onResize);
    onResize();
  }

  function componentDidUpdate() {}

  function componentWillUnmount() {
    window.removeEventListener("resize", onResize);
  }

  function onResize() {
    const deviceWidth = window.innerWidth;
    const deviceHeight = window.innerHeight;

    const uiUniPlayPage = document.getElementById("uniPlayPage");
    if (uiUniPlayPage) {
      uiUniPlayPage.style.height = `${deviceHeight}px`;
      uiUniPlayPage.style.overflowY = "auto";
    }
  }

  function onBack() {
    //AppCtrl.askMachineTokenInLobby();
    setFunc(EFunction.winLobby);
    // navigate('/lobby');
  }

  function onChangeExchangeUniPlayToFormal(e) {
    let strScores = "";
    for (let i = 0; i < e.target.value.length; i++) {
      const ch = e.target.value[i];
      if (
        ch == "0" ||
        ch == "1" ||
        ch == "2" ||
        ch == "3" ||
        ch == "4" ||
        ch == "5" ||
        ch == "6" ||
        ch == "7" ||
        ch == "8" ||
        ch == "9"
      ) {
        strScores += ch;
      }
    }
    setScoresUniPlayToFormal(strScores);
  }

  function onExchangeUniPlayToFormalOk() {
    const language = AppCtrl.getLanguage();
    const scores = parseInt(scoresUniPlayToFormal);
    if(userUniPlayScores < scores){
      if (language == LANGUAGE_TYPE.zh_TW) {
          showAlert({ title: "跨館幣不足或有誤" });
        }
        else{
          showAlert({ title: "Score is not enough." });
        }
    }
    else{
      AppCtrl.exchangeUniPlayToFormal(scores);
    }


  }

  function onChangeExchangeFormalToUniPlay(e) {
    let strScores = "";
    for (let i = 0; i < e.target.value.length; i++) {
      const ch = e.target.value[i];
      if (
        ch == "0" ||
        ch == "1" ||
        ch == "2" ||
        ch == "3" ||
        ch == "4" ||
        ch == "5" ||
        ch == "6" ||
        ch == "7" ||
        ch == "8" ||
        ch == "9"
      ) {
        strScores += ch;
      }
    }
    setScoresFormalToUniPlay(strScores);
  }

  function onExchangeFormalToUniPlayOk() {
    const scores = parseInt(scoresFormalToUniPlay);
    AppCtrl.exchangeFormalToUniPlay(scores);
  }

  function onUniPlayLobbyChange() {
    const uiUniPlaySelect = document.getElementById("uniPlaySelect");
    if (uiUniPlaySelect) {
      const index = uiUniPlaySelect.selectedIndex;
      const option = uiUniPlaySelect.options[index];
      console.log(`${index}, ${option.label}`);

      const uniPlayList = AppCtrl.uniPlayList();
      uniPlayList.forEach((info) => {
        if (info.name === option.value) {
          // change img
          setUniPlayLobbyImg(info.img);
          // change desc
          setUniPlayLobbyDesc(info.desc);
        }
      });
    }
  }

  function onStartUniPlay() {
    const mainSettings = AppCtrl.mainSettings();
    const domainUrl = mainSettings.Domain;
    if (domainUrl && domainUrl.length > 0) {
      const userInfo = AppCtrl.userInfo();
      if (mainSettings.VerifyUserInfo && !userInfo.Verified) {
        setFunc(EFunction.verifyPhone);
        // navigate('/verify-phone');
        if (language == LANGUAGE_TYPE.en_US)
          showAlert({ title: "Verify account to enjoy more benefit." });
        // AppCtrl.alert("Verify account to enjoy more benefit.");
        else showAlert({ title: "驗證帳號能享受更多遊戲權利。" });
        // AppCtrl.alert("驗證帳號能享受更多遊戲權利。");
      } else {
        setUniPlayStartDisabled(true);

        const uiUniPlaySelect = document.getElementById("uniPlaySelect");
        if (uiUniPlaySelect) {
          const index = uiUniPlaySelect.selectedIndex;
          const option = uiUniPlaySelect.options[index];

          if (userUniPlayScores >= 0) {
            const uniPlayList = AppCtrl.uniPlayList();
            uniPlayList.forEach((info) => {
              if (info.name === option.value) {
                AppCtrl.startUniPlay(
                  info.name,
                  userUniPlayScores,
                  function (objRes) {
                    const status = objRes.status;
                    if (status == "success") {
                      AppCtrl.getUserScores();
                      AppCtrl.SetNewLogin(true);
                      AppCtrl.getUserInfo(function (obj) {
                        AppCtrl.requestLobbies();
                        // show winLobbyPage for avatar to choose winLobbyManager
                        setFunc(EFunction.winLobby);
                        // navigate('/lobby');
                      });
                    } else {
                      const err = objRes.error;
                      showAlert({ title: err });
                      // AppCtrl.alert(err);
                    }
                    // enable
                    setUniPlayStartDisabled(false);
                  }
                );
              }
            });
          } else {
            showAlert({ title: AppCtrl.textConverter().convert("無效的分數") });
            // AppCtrl.alert(AppCtrl.textConverter().convert('無效的分數'));
          }
        }
      }
    }
  }

  function onStopUniPlay() {
    AppCtrl.stopUniPlay(function (objRes) {
      const status = objRes.status;
      if (status === "success") {
        setUniPlayInfo(null);
        showAlert({ title: "OK" });
        // AppCtrl.alert('OK');
      } else {
        showAlert({ title: "Error" });
        // AppCtrl.alert('Error');
      }
    });
  }

  return (
    <div id="uniPlayPage" className={styles.uniPlayPage}>
      <div className={styles.mainArea}>
        <div>
          <h3>{`${text.uniPlay}`}</h3>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              textAlign: "left",
              fontSize: "18px",
              width: "100%",
              height: "120px",
              color: "white",
            }}
          >
            <div
              style={{ margin: "0px 10px", width: "60%", textAlign: "left" }}
            >
              <div>
                {textUser}:{userName}
              </div>
              <div>
                {textGold}:{userFormalScores}
              </div>
              <div>
                {textUniPlay}:{userUniPlayScores}
              </div>
            </div>
            <div
              style={{ margin: "0px 10px", width: "40%", textAlign: "right" }}
            >
              <button
                className="large red button"
                style={{
                  margin: "5px auto",
                  width: "100%",
                  height: "50px",
                  maxWidth: "160px",
                  fontSize: "16px",
                }}
                onClick={onBack}
              >{`${text.back}`}</button>
              {uniPlayInfo ? (
                <button
                  className="large green button"
                  style={{
                    margin: "5px auto",
                    width: "100%",
                    height: "50px",
                    maxWidth: "160px",
                    fontSize: "16px",
                  }}
                  onClick={onStopUniPlay}
                >{`${text.stopUniPlay}`}</button>
              ) : null}
            </div>
          </div>
          <hr></hr>
        </div>
        {canExchangeFormalToUniPlay ? (
          <div>
            <h3>{titleFormalToUniPlay}</h3>
            <div
              style={{
                textAlign: "left",
                fontSize: "14px",
                width: "100%",
                color: "white",
              }}
            >{`${text.appliedGolds}:`}</div>
            <div style={{ margin: "10 auto", width: "100%" }}>
              <input
                type="text"
                style={{
                  width: "80%",
                  fontSize: "18px",
                  height: "30px",
                  textAlign: "center",
                  color: "black",
                }}
                value={scoresFormalToUniPlay}
                placeholder={`${text.appliedGoldsPlaceholder}`}
                onChange={onChangeExchangeFormalToUniPlay}
              />
            </div>
            <div style={{ paddingTop: "10px" }}>
              <button
                className="large blue button"
                style={{ width: "48%", height: "40px", fontSize: "18px" }}
                onClick={onExchangeFormalToUniPlayOk}
              >{`${text.confirm}`}</button>
            </div>
            <hr></hr>
          </div>
        ) : null}
        {canExchangeUniPlayToFormal ? (
          <div>
            <h3>{titleUniPlayToFormal}</h3>
            <div
              style={{
                textAlign: "left",
                fontSize: "14px",
                width: "100%",
                color: "white",
              }}
            >{`${text.appliedGoldsBack}:`}</div>
            <div style={{ margin: "10 auto", width: "100%" }}>
              <input
                type="text"
                style={{
                  width: "80%",
                  fontSize: "18px",
                  height: "30px",
                  textAlign: "center",
                  color: "black",
                }}
                value={scoresUniPlayToFormal}
                placeholder={`${text.appliedGoldsPlaceholder}`}
                onChange={onChangeExchangeUniPlayToFormal}
              />
            </div>
            <div style={{ paddingTop: "10px" }}>
              <button
                className="large blue button"
                style={{ width: "48%", height: "40px", fontSize: "18px" }}
                onClick={onExchangeUniPlayToFormalOk}
              >{`${text.confirm}`}</button>
            </div>
            <hr></hr>
          </div>
        ) : null}
        {uniLobbyies.length > 0 ? (
          <div style={{ margin: "10px" }}>
            <div>
              <select
                id="uniPlaySelect"
                className={styles.selectUniPlay}
                onChange={onUniPlayLobbyChange}
              ></select>
            </div>
            <div
              style={{
                margin: "20px",
                padding: "10px",
                backgroundColor: "rgba(0, 0, 0, 0.8)",
                borderRadius: "20px",
              }}
            >
              <div style={{ display: "flex", flexDirection: "row" }}>
                <div style={{ width: "50%" }}>
                  <img
                    src={uniPlayLobbyImg}
                    style={{
                      width: "100%",
                      minWidth: "70px",
                      height: "100%",
                      minHeight: "70px",
                      objectFit: "contain",
                    }}
                  ></img>
                </div>
                <div style={{ width: "50%" }}>
                  <div style={{ margin: "20px 10px", textAlign: "center" }}>
                    <span>
                      {text.transferedScores}: {userUniPlayScores} (
                      {textUniPlay})
                    </span>
                  </div>
                  <button
                    className="large blue button"
                    style={{
                      width: "80%",
                      height: "50px",
                      maxWidth: "160px",
                      fontSize: "16px",
                    }}
                    onClick={onStartUniPlay}
                    disabled={uniPlayStartDisabled}
                  >{`${text.startUniPlay}`}</button>
                </div>
              </div>
              <div
                style={{
                  width: "100%",
                  textAlign: "left",
                  wordWrap: "break-word",
                }}
              >
                {uniPlayLobbyDesc}
              </div>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default UniPlayPage;
